export default {
  SET_USER(state, payload) {
    state.user = payload
  },
  SET_TOKEN(state, payload) {
    state.token = payload
  },
  SET_GOOGLE_API(state, payload) {
    state.googleApi = payload
  },
  setOpusPayload(state, payload) {
    state.opusPayload = payload
  },
  autoRefreshToken(state, payload) {
    state.autoRefreshToken = payload
  },
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, payload) {
    state.status = 'success'
    state = { ...state, ...payload }
  },
  auth_error(state) {
    state.status = 'error'
  },
  logout(state) {
    state.status = null
    state.token = null
    state.googleApi = null
    state.exp = null
  },
}
